<template>
  <div class="w-full px-6 py-4">
    <div class="mb-5 flex items-center">
      <o-icon icon="customFields" :size="20" class="mr-3 opacity-75" />
      <div>
        <p class="leading-none mb-1">
          {{ $t('general.customFields') }}
        </p>
        <p class="leading-none text-sm opacity-60">
          {{ $t('components.customer.edit.custom.info') }}
        </p>
      </div>
    </div>

    <o-custom-fields :data="customer.customFields">
      <template #default="{fields}">
        <div v-if="!fields.length" class="p-3 bg-gray-50 rounded-md w-full text-sm text-gray-700">
          <p>{{ $t('components.customer.edit.custom.noFields') }}</p>
        </div>

        <div
          v-for="field in fields"
          :key="field.props.id"
          class="flex space-x-4 mb-4"
        >
          <o-field-group class="w-full" :label="field.label">
            <component
              :is="field.component"
              v-bind="field.props"
              v-on="field.events"
            />
          </o-field-group>
        </div>
      </template>
    </o-custom-fields>
  </div>
</template>

<script setup lang="ts">
import {
  OCustomFields,
} from '@/components/elements'

interface Props {
  customer: Record<string, any>
}

defineProps<Props>()
</script>
